<template>

<div v-if='$parent.isLoading || !$parent.isReady'>
    <img src='/resources/loader.svg'>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {

            }
        },

        methods : {

        }

    }
</script>
